module.exports = __webpack_public_path__ + "assets/img/index-banner2-2.1046ca38.png";